<tr class="assignment-table-row-container" *transloco="let t; prefix: 'vehicleAssignment'">
  <td class="p-3">
    <div class="driver-profile__td d-flex align-items-center gap-2">
      <app-avatar [imageSrc]="driver.profilePictureUrl ?? null"
      [name]="getDriverName(driver.firstName, driver.lastName)" [size]="32"></app-avatar>
      <div
        [ngbTooltip]="getDriverName(driver.firstName, driver.lastName).length > 20 ? getDriverName(driver.firstName, driver.lastName) : null"
        [autoClose]="'outside'">
        {{ getDriverName(driver.firstName, driver.lastName) | truncatetext:20 }}
      </div>
      @if (driver.deleted) {
        <div class="driver-deleted-indicator"
          [ngbTooltip]="t('row.driverDeleted')" placement="top">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="9" fill="rgb(244, 188, 43)" stroke="rgb(244, 188, 43)" stroke-width="2" />
            <line x1="10" y1="14" x2="10" y2="10" stroke="white" stroke-width="2" />
            <circle cx="10" cy="6" r="1" fill="white" />
          </svg>
        </div>
      }
    </div>
  </td>

  <td class="p-2">
    @if (assignedVehicles?.length) {
      <div class="vehicle-tags">
        @if (assignedVehicles.length > 3) {
          <div class="scroll-button left-rounded"
            (click)="scrollVehicleTags('assigned', driver.driverId, 'left')">
            <i class="ph ph-caret-left"></i>
          </div>
        }
        <div class="vehicle-tags-scroll-inner" [id]="'assigned-' + driver.driverId" #assignedVehicleTagsScrollArea>
          @for (vehicle of assignedVehicles; track vehicle) {
            <div class="vehicle-tag assigned">
              <span [ngbTooltip]="vehicle.assetName.length >= 5 ? vehicle.assetName : null">
                {{ vehicle.assetName | truncatetext:5 }}
              </span>
              @if (hasFleetManagerRole && !driver.deleted) {
                <span class="unassign-icon"
                  (click)="handleSingleUnassignModal(driver, vehicle)">
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_17415_2778)">
                      <path
                        d="M13.7081 12.2926C13.801 12.3855 13.8747 12.4958 13.9249 12.6172C13.9752 12.7386 14.0011 12.8687 14.0011 13.0001C14.0011 13.1315 13.9752 13.2616 13.9249 13.383C13.8747 13.5044 13.801 13.6147 13.7081 13.7076C13.6151 13.8005 13.5048 13.8742 13.3835 13.9245C13.2621 13.9747 13.132 14.0006 13.0006 14.0006C12.8692 14.0006 12.7391 13.9747 12.6177 13.9245C12.4963 13.8742 12.386 13.8005 12.2931 13.7076L4.00056 5.41382L-4.29194 13.7076C-4.47958 13.8952 -4.73408 14.0006 -4.99944 14.0006C-5.26481 14.0006 -5.5193 13.8952 -5.70694 13.7076C-5.89458 13.5199 -6 13.2654 -6 13.0001C-6 12.7347 -5.89458 12.4802 -5.70694 12.2926L2.58681 4.00007L-5.70694 -4.29243C-5.89458 -4.48007 -6 -4.73457 -6 -4.99993C-6 -5.2653 -5.89458 -5.51979 -5.70694 -5.70743C-5.5193 -5.89507 -5.26481 -6.00049 -4.99944 -6.00049C-4.73408 -6.00049 -4.47958 -5.89507 -4.29194 -5.70743L4.00056 2.58632L12.2931 -5.70743C12.4807 -5.89507 12.7352 -6.00049 13.0006 -6.00049C13.2659 -6.00049 13.5204 -5.89507 13.7081 -5.70743C13.8957 -5.51979 14.0011 -5.2653 14.0011 -4.99993C14.0011 -4.73457 13.8957 -4.48007 13.7081 -4.29243L5.41431 4.00007L13.7081 12.2926Z"
                        fill="#9FA1A4" />
                      </g>
                      <defs>
                        <clipPath id="clip0_17415_2778">
                          <rect width="8" height="8" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                }
              </div>
            }
            @if (assignedVehicles.length >= 5) {
              <div class="see-all" (click)="handleShowAll(driver, 'assigned')">{{ 'common.seeAll' | transloco }}
              </div>
            }
          </div>
          @if (assignedVehicles.length > 3) {
            <div class="scroll-button right-rounded"
              (click)="scrollVehicleTags('assigned', driver.driverId, 'right')">
              <i class="ph ph-caret-right"></i>
            </div>
          }
        </div>
      }
    </td>

    <td class="p-2">
      @if (pendingAssignmentVehicles?.length) {
        <div class="vehicle-tags">
          @if (pendingAssignmentVehicles.length > 3) {
            <div class="scroll-button left-rounded"
              (click)="scrollVehicleTags('pending', driver.driverId, 'left')">
              <i class="ph ph-caret-left"></i>
            </div>
          }
          <div class="vehicle-tags-scroll-inner" [id]="'pending-' + driver.driverId" #pendingVehicleTagsScrollArea>
            @for (vehicle of pendingAssignmentVehicles; track vehicle) {
              <div class="vehicle-tag pending-assignment"
                [ngbTooltip]="vehicle.assetName.length > 5 ? vehicle.assetName : null">
                {{ vehicle.assetName | truncatetext:5 }}
                @if (hasFleetManagerRole && !driver.deleted) {
                  <span class="unassign-icon"
                    (click)="cancelPendingSingleUnassignModal(driver, vehicle)">
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_17415_2778)">
                        <path
                          d="M13.7081 12.2926C13.801 12.3855 13.8747 12.4958 13.9249 12.6172C13.9752 12.7386 14.0011 12.8687 14.0011 13.0001C14.0011 13.1315 13.9752 13.2616 13.9249 13.383C13.8747 13.5044 13.801 13.6147 13.7081 13.7076C13.6151 13.8005 13.5048 13.8742 13.3835 13.9245C13.2621 13.9747 13.132 14.0006 13.0006 14.0006C12.8692 14.0006 12.7391 13.9747 12.6177 13.9245C12.4963 13.8742 12.386 13.8005 12.2931 13.7076L4.00056 5.41382L-4.29194 13.7076C-4.47958 13.8952 -4.73408 14.0006 -4.99944 14.0006C-5.26481 14.0006 -5.5193 13.8952 -5.70694 13.7076C-5.89458 13.5199 -6 13.2654 -6 13.0001C-6 12.7347 -5.89458 12.4802 -5.70694 12.2926L2.58681 4.00007L-5.70694 -4.29243C-5.89458 -4.48007 -6 -4.73457 -6 -4.99993C-6 -5.2653 -5.89458 -5.51979 -5.70694 -5.70743C-5.5193 -5.89507 -5.26481 -6.00049 -4.99944 -6.00049C-4.73408 -6.00049 -4.47958 -5.89507 -4.29194 -5.70743L4.00056 2.58632L12.2931 -5.70743C12.4807 -5.89507 12.7352 -6.00049 13.0006 -6.00049C13.2659 -6.00049 13.5204 -5.89507 13.7081 -5.70743C13.8957 -5.51979 14.0011 -5.2653 14.0011 -4.99993C14.0011 -4.73457 13.8957 -4.48007 13.7081 -4.29243L5.41431 4.00007L13.7081 12.2926Z"
                          fill="#9FA1A4" />
                        </g>
                        <defs>
                          <clipPath id="clip0_17415_2778">
                            <rect width="8" height="8" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  }
                </div>
              }
              @if (pendingAssignmentVehicles.length >= 5) {
                <div class="see-all"
                  (click)="handleShowAll(driver, 'pending-assignment')">{{ 'common.seeAll' | transloco }}</div>
              }
            </div>
            @if (pendingAssignmentVehicles.length > 3) {
              <div class="scroll-button right-rounded"
                (click)="scrollVehicleTags('pending', driver.driverId, 'right')">
                <i class="ph ph-caret-right"></i>
              </div>
            }
          </div>
        }
      </td>

      <td class="p-2">
        @if (pendingUnassignmentVehicles?.length) {
          <div class="vehicle-tags">
            @if (pendingUnassignmentVehicles.length > 3) {
              <div class="scroll-button left-rounded"
                (click)="scrollVehicleTags('pending-unassign', driver.driverId, 'left')">
                <i class="ph ph-caret-left"></i>
              </div>
            }
            <div class="vehicle-tags-scroll-inner" [id]="'pending-unassign-' + driver.driverId"
              #pendingUnassignmentTagsScrollArea>
              @for (vehicle of pendingUnassignmentVehicles; track vehicle) {
                <div class="vehicle-tag pending-unassignment"
                  [ngbTooltip]="vehicle.assetName.length > 5 ? vehicle.assetName : null">
                  {{ vehicle.assetName | truncatetext:5 }}
                  @if (hasFleetManagerRole && !driver.deleted) {
                    <span class="unassign-icon"
                      (click)="handleCancelUnAssignment(driver, vehicle)">
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_17415_2778)">
                          <path
                            d="M13.7081 12.2926C13.801 12.3855 13.8747 12.4958 13.9249 12.6172C13.9752 12.7386 14.0011 12.8687 14.0011 13.0001C14.0011 13.1315 13.9752 13.2616 13.9249 13.383C13.8747 13.5044 13.801 13.6147 13.7081 13.7076C13.6151 13.8005 13.5048 13.8742 13.3835 13.9245C13.2621 13.9747 13.132 14.0006 13.0006 14.0006C12.8692 14.0006 12.7391 13.9747 12.6177 13.9245C12.4963 13.8742 12.386 13.8005 12.2931 13.7076L4.00056 5.41382L-4.29194 13.7076C-4.47958 13.8952 -4.73408 14.0006 -4.99944 14.0006C-5.26481 14.0006 -5.5193 13.8952 -5.70694 13.7076C-5.89458 13.5199 -6 13.2654 -6 13.0001C-6 12.7347 -5.89458 12.4802 -5.70694 12.2926L2.58681 4.00007L-5.70694 -4.29243C-5.89458 -4.48007 -6 -4.73457 -6 -4.99993C-6 -5.2653 -5.89458 -5.51979 -5.70694 -5.70743C-5.5193 -5.89507 -5.26481 -6.00049 -4.99944 -6.00049C-4.73408 -6.00049 -4.47958 -5.89507 -4.29194 -5.70743L4.00056 2.58632L12.2931 -5.70743C12.4807 -5.89507 12.7352 -6.00049 13.0006 -6.00049C13.2659 -6.00049 13.5204 -5.89507 13.7081 -5.70743C13.8957 -5.51979 14.0011 -5.2653 14.0011 -4.99993C14.0011 -4.73457 13.8957 -4.48007 13.7081 -4.29243L5.41431 4.00007L13.7081 12.2926Z"
                            fill="#9FA1A4" />
                          </g>
                          <defs>
                            <clipPath id="clip0_17415_2778">
                              <rect width="8" height="8" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    }
                  </div>
                }
                @if (pendingUnassignmentVehicles.length >= 5) {
                  <div class="see-all"
                  (click)="handleShowAll(driver, 'pending-unassignment')">{{ 'common.seeAll' | transloco }}</div>
                }
              </div>
              @if (pendingUnassignmentVehicles.length > 3) {
                <div class="scroll-button right-rounded"
                  (click)="scrollVehicleTags('pending-unassign', driver.driverId, 'right')">
                  <i class="ph ph-caret-right"></i>
                </div>
              }
            </div>
          }
        </td>

        @if (hasFleetManagerRole ) {
          <td class="p-2 action-col">
            <button type="submit" class="btn btn-primary" [disabled]="driver.deleted" (click)="handleSingleAssignModal(driver)">
              <span>{{ 'common.assign' | transloco }}</span>
            </button>
          </td>
        }
      </tr>